export const APP_CONFIG = {
appName: 'Core OnePage',
frontend: 'https://onepage.builtoncore.com',
apiHash: 'https://onepage.builtoncore.com/api/1.0',
api: '/api/2.0',
trustModel: false,
authHeaders: {
xServiceProvider: 'onepage-prod-frontend',
'tenant-id': '69ae7ba0-3766-465e-a61e-e590087f64e2',
'consumer-id': 'efaee42f-29b3-4ad9-9771-16b14b49e45a',
},
provider: 'onepage-prod-frontend',
gtm: '',
multilingual: true,
copyright: '&copy; ' + new Date().getFullYear() + ' Gallagher. All Rights Reserved.',
demoMode: false,
chatEnabled: false,
isDarkModeEnabled: false,
colors: {
primary: '#1297f3',
secondary: '#3d353e',
},
navigation: {
navType: 'top',
collapsibleSidenav: false,
headerStyle: 'transparent',
categoryNav: true
}
};
